import { Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio } from 'components/atoms/radio';
import { Filter } from 'components/molecules/filters/types';
import { ProjectTargets } from 'data/templates/status-updates';
import { useTranslation } from 'hooks/use-translation';
import { ProjectsFilter } from './projects-filter';
import { ConfigTitle } from './styles';

interface Props {
  projectFilter: Filter;
  projectTarget: ProjectTargets;
  onProjectTargetChange: (val: ProjectTargets) => void;
}

export const ProjectsSelector = ({
  projectFilter,
  projectTarget,
  onProjectTargetChange,
}: Props): React.ReactElement => {
  const projectTargets = [
    {
      label: useTranslation(
        'templates.status_updates.tab.config.publish.projects.all',
      ),
      value: ProjectTargets.All,
    },
    {
      label: useTranslation(
        'templates.status_updates.tab.config.publish.projects.filtered',
        {
          filterType: projectFilter.type,
          strong: (chunks) => (
            <Typography.Text strong>{chunks}</Typography.Text>
          ),
        },
      ),
      value: ProjectTargets.Filtered,
    },
  ];

  const onProjectTargetUpdate = (e) => {
    onProjectTargetChange(e.target.value);
  };

  return (
    <>
      <ConfigTitle>
        <FormattedMessage id="templates.status_updates.tab.config.projects" />
      </ConfigTitle>
      <Radio.Group
        options={projectTargets}
        onChange={onProjectTargetUpdate}
        value={projectTarget}
      />
      {projectTarget === ProjectTargets.Filtered ? <ProjectsFilter /> : null}
    </>
  );
};
